var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoIntegracoes01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_390",
    x: 0.1,
    y: 0.1,
    className: "st0",
    width: 35.8,
    height: 35.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "importar",
    transform: "translate(5 4.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_905",
    d: "M24,4.9h-5.8v3.5H24c1.7,0,3.1,0.9,3.1,1.7v15.4c0,0.8-1.3,1.7-3.1,1.7H2c-1.7,0-3.1-0.9-3.1-1.7V10.1 c0-0.8,1.3-1.7,3.1-1.7h5.8V4.9H2c-3.7,0-6.5,2.3-6.5,5.1v15.4c0,2.9,2.9,5.1,6.5,5.1h22c3.7,0,6.5-2.3,6.5-5.1V10.1 C30.5,7.2,27.7,4.9,24,4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_906",
    d: "M18.1,12c-0.5,0-0.9,0.2-1.2,0.5l-2.1,2.1V-2.6c0-0.9-0.8-1.7-1.7-1.7c-0.9,0-1.7,0.8-1.7,1.7v17.4 l-2.2-2.2c-0.7-0.7-1.7-0.7-2.4,0c-0.7,0.7-0.7,1.7,0,2.4l5.1,5.1c0.3,0.3,0.8,0.5,1.2,0.5h0c0.5,0,0.9-0.2,1.2-0.5l5.1-5.1 c0.7-0.7,0.7-1.7,0-2.4C19,12.2,18.6,12,18.1,12L18.1,12z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoIntegracoes01);
export default __webpack_public_path__ + "static/media/ico-integracoes-01.8f1980c398586208f9c46a768bf1e925.svg";
export { ForwardRef as ReactComponent };